import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GeneralEmailSettingsContainer = lazy(() =>
  import("@scenes/EmailSettings/GeneralEmailSettings/GeneralEmailSettingsContainer").then((module) => ({
    default: module.GeneralEmailSettingsContainer,
  }))
);

export const sendingConfigurationNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("sending-configuration-nro-heading", "Sending Configuration"),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  Component: GeneralEmailSettingsContainer,
  componentFeatureFlippers: ["sending_configuration_nro_component", "email_preferences_nro_component"],
};
